import React, { useState } from "react";
import { Navbar, Nav, Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "../pages/HomeNew.css";

const AppNavbar = () => {
  const [expanded, setExpanded] = useState(false);

  return (
    <Navbar
      bg="dark"
      variant="dark"
      expand="lg"
      sticky="top"
      expanded={expanded}
    >
      <Container className="site-header">
        <Navbar.Brand
          className="brand"
          as={Link}
          to="/"
          onClick={() => setExpanded(false)}
        >
          <img src="logo 192.png" alt="Vachana Group" className="logo" />
          <span className="site-title">Vachana Group</span>
        </Navbar.Brand>

        {/* Hamburger Toggle */}
        <Navbar.Toggle
          aria-controls="main-navbar"
          onClick={() => setExpanded(expanded ? false : "expanded")}
        />

        <Navbar.Collapse id="main-navbar">
          <Nav className="ms-auto">
            <Nav.Link
              href="#companies"
              className="nav-bubble"
              onClick={() => setExpanded(false)}
            >
              Companies
            </Nav.Link>

            <Nav.Link
              as={Link}
              to="/contact"
              className="nav-bubble"
              onClick={() => setExpanded(false)}
            >
              Contact
            </Nav.Link>

            <Nav.Link
              as={Link}
              to="/gallery"
              className="nav-bubble"
              onClick={() => setExpanded(false)}
            >
              Gallery
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default AppNavbar;
